/**
 * Metadatos del último respaldo JSON generado con éxito en este navegador.
 * No hay endpoint/BD de «último respaldo» en el backend; se reutiliza localStorage.
 */

export const LAST_BACKUP_STORAGE_KEY = "icjeme_last_backup_meta";

/**
 * @returns {{ downloadedAt: string, fileName: string|null } | null}
 */
export function getLastBackupMeta() {
  try {
    const raw = localStorage.getItem(LAST_BACKUP_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const downloadedAt = String(parsed?.downloadedAt || "").trim();
    if (!downloadedAt) return null;
    const fileName = parsed?.fileName != null ? String(parsed.fileName).trim() : "";
    return {
      downloadedAt,
      fileName: fileName || null,
    };
  } catch {
    return null;
  }
}

/**
 * Solo llamar tras una generación/descarga exitosa.
 * @param {{ fileName?: string|null, downloadedAt?: string }} args
 */
export function recordLastBackupMeta({ fileName = null, downloadedAt } = {}) {
  const meta = {
    downloadedAt: downloadedAt || new Date().toISOString(),
    fileName: fileName ? String(fileName).trim() : null,
  };
  try {
    localStorage.setItem(LAST_BACKUP_STORAGE_KEY, JSON.stringify(meta));
  } catch {
    /* ignore quota / private mode */
  }
  return meta;
}

/** Fecha día/mes/año + hora legible (es-MX). */
export function formatLastBackupWhen(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  try {
    const date = d.toLocaleDateString("es-MX", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    const time = d.toLocaleTimeString("es-MX", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
    return `${date} — ${time}`;
  } catch {
    return null;
  }
}
